import { SSE } from "../../common/apiUrl/sse/sseUrl";
import { DocumentRequestJson, SendMessageJsonRequestBody } from "../../common/model/sse/jsonRequest"
import { generateCallbackCurlCommand, generateCurlCommand, generateNoBodyCurlCommand } from "../helperFunctions";

 const sendMessageJsonRequest: SendMessageJsonRequestBody = {
    recipients: ["string"],
    subject: "string",
    body: "string",
    retentionPeriod: "OneDay",
    attachments: ["string"],
    callbackUri: "string",
    correlationId: "string"
};

export const sendMessageJsonRequestCurl = generateCallbackCurlCommand(
    SSE.COMPOSE_MESSAGE.sendMessage,
    "POST",
    sendMessageJsonRequest
  );
  
  const documentRequestJson : DocumentRequestJson = {
    recipients: ["string"],
    subject: "string",
    templateName: "string",
    retentionPeriod: "OneDay",
    notifyOnCompletion: false
}

export const documentRequestJsonRequestCurl = generateCurlCommand(
    SSE.DOCUMENT_REQUEST.documentRequest,
    "POST",
    documentRequestJson
  )

  export const documentRequestTemplateJsonRequestCurl = generateNoBodyCurlCommand(
    SSE.DOCUMENT_REQUEST_TEMPLATE.documentRequestTemplate,
    "GET",
  )